// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3R1Jy","modalForm":"UpgradeEpcsModal_modalForm__1lWT5","modalFooter":"UpgradeEpcsModal_modalFooter__1dY_g"};